/* import __COLOCATED_TEMPLATE__ from './step-block.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import templateOnly from '@ember/component/template-only';
interface Signature {
  Element: HTMLElement;
  Args: {
    variant?: 'dot' | 'number';
    number?: number;
    bottomSpacing?: 'default' | 'compact';
  };
  Blocks: {
    default: [];
  };
}
const PulseCandidateStepBlockComponent = templateOnly<Signature>();
export default PulseCandidateStepBlockComponent;
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'PulseCandidate::StepBlock': typeof PulseCandidateStepBlockComponent;
    'pulse-candidate/step-block': typeof PulseCandidateStepBlockComponent;
  }
}
